import { Navigate, useLocation, useSearchParams } from "react-router-dom"

export const PrivateRoute = ({ children, isAuthenticated }) => {
    const location = useLocation();
    localStorage.setItem('lastPage', location.pathname);

    return isAuthenticated ? children : <Navigate to="/login" />
}

